function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconCreditCard = function SvgIconCreditCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: props.color,
    d: "M1 8.5h22M.5 18V6C.5 5 1 4.5 2 4.5h20c1 0 1.5.5 1.5 1.5v12c0 1-.5 1.5-1.5 1.5H2C1 19.5.5 19 .5 18z"
  }));
};
export default SvgIconCreditCard;